var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.266 14.354L18 17.44V31C17.9994 33.0063 17.3284 34.9549 16.0937 36.5363C14.8589 38.1176 13.1312 39.241 11.1849 39.7281C9.23863 40.2152 7.1854 40.0379 5.35136 39.2246C3.51732 38.4112 2.00764 37.0083 1.06213 35.2388C0.116607 33.4693 -0.210532 31.4345 0.132669 29.4578C0.475871 27.4811 1.46973 25.6757 2.95639 24.3284C4.44305 22.9812 6.33725 22.1693 8.33813 22.0217C10.339 21.8742 12.3318 22.3994 14 23.514V8.88403C14 7.62483 14.3961 6.39754 15.1323 5.37597C15.8685 4.35441 16.9075 3.59036 18.102 3.19203L26.052 0.542028C26.5029 0.391842 26.9831 0.35094 27.4529 0.422688C27.9227 0.494437 28.3688 0.676784 28.7543 0.954709C29.1399 1.23263 29.4539 1.59818 29.6704 2.02124C29.887 2.4443 30 2.91276 30 3.38803V10.558C30.0004 11.3976 29.7365 12.2161 29.2458 12.8974C28.7551 13.5787 28.0625 14.0883 27.266 14.354Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.baac881defba15b1d3e653f4139e78eb.svg";
export { ForwardRef as ReactComponent };